<template>
<div>
  <div style="margin: 0 20px"> <el-button size="small" type="primary" plain icon="el-icon-plus" @click="addOldPersonLink()">添加紧急联系人</el-button></div>
  <div style="margin: 0 20px;padding-bottom: 20px">
    <el-table :data="tableData" style="width: 100%">
      <el-table-column
        prop="family_name"
        label="紧急联系人姓名"
        min-width="120">
      </el-table-column>
      <el-table-column
        prop="family_relation"
        label="与老人关系"
        min-width="80">
      </el-table-column>
      <el-table-column
        prop="family_address"
        label="地址"
        min-width="120">
      </el-table-column>
      <el-table-column
        prop="family_phone"
        label="联系电话"
        min-width="120">
      </el-table-column>
      <el-table-column
        prop="family_home_phone"
        label="固定电话"
        min-width="120">
      </el-table-column>
      <el-table-column
        prop="family_remark"
        label="备注"
        min-width="80">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="editLink(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="delLink(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <el-dialog width="600px" :title="titleName" :visible.sync="addEditShow" v-if="addEditShow" append-to-body center>
    <el-form size="small" style="margin-right: 30px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="140px" class="demo-ruleForm">
      <el-form-item label="紧急联系人姓名" prop="family_name">
        <el-input v-model="addEditForm.family_name" placeholder="请输入紧急联系人姓名"></el-input>
      </el-form-item>
      <el-form-item label="与老人的关系" prop="family_relation">
        <el-select v-fixZoom v-model="addEditForm.family_relation" filterable placeholder="请选择" style="width: 100%">
          <el-option v-for="item in relationArr" :key="item.id" :label="item.name" :value="item.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="地址" prop="">
        <el-input v-model="addEditForm.family_address" placeholder="请输入地址"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="">
        <el-input v-model="addEditForm.family_phone" placeholder="请输入联系电话"></el-input>
      </el-form-item>
      <el-form-item label="固定电话" prop="">
        <el-input v-model="addEditForm.family_home_phone" placeholder="请输入固定电话"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="">
        <el-input v-model="addEditForm.family_remark" placeholder="请输入备注"></el-input>
      </el-form-item>
    </el-form>
    <div style="margin-top: 30px;height: 50px">
      <el-row style="margin: 0 20px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeAddEdit()">
            <span>取消</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="submitAddEditUnit('addEditForm')">
            <span>确定</span>
          </div>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</div>
</template>

<script>
import {queryelderlyfamilyperson, createelderlyfamilyperson, updateelderlyfamilyperson, deleteelderlyfamilyperson} from '../../../api/yanglaoyuan'

export default {
  name: 'kinsmanInfo',
  props: {
    kinsmanObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      oldPersonRow: '',
      tableData: [],
      titleName: '添加紧急联系人',
      addEditShow: false,
      isAdd: true,
      addEditForm: {
        id: 0,
        ep_id: 0,
        family_name: '',
        family_relation: '',
        family_phone: '',
        family_home_phone: '',
        family_address: '',
        family_remark: ''
      },
      addEditRules: {
        family_name: [
          {required: true, message: '请输入紧急联系人姓名', trigger: 'blur'}
        ],
        family_relation: [
          {required: true, message: '请选择与老人的关系', trigger: 'blur'}
        ]
      },
      relationArr: []
    }
  },
  created () {
    this.relationArr = this.commonType.getRelationShipArr()
    this.oldPersonRow = this.kinsmanObj.oldPersonRow
    if (this.oldPersonRow === '' || this.oldPersonRow.id === 0) {
      this.$message({
        message: '请先新增老人基本信息。',
        type: 'warning'
      })
    } else {
      this.addEditForm.ep_id = this.oldPersonRow.id
      this.getFamilyTable()
    }
  },
  methods: {
    getFamilyTable () {
      let data = {
        ep_id: this.oldPersonRow.id
      }
      queryelderlyfamilyperson(data).then(res => {
        this.tableData = res.data.elderlyfamily
      })
    },
    addOldPersonLink () {
      this.titleName = '添加紧急联系人'
      this.isAdd = true
      this.addEditForm = {
        id: 0,
        ep_id: this.oldPersonRow.id ? this.oldPersonRow.id : 0,
        family_name: '',
        family_relation: '',
        family_phone: '',
        family_home_phone: '',
        family_address: '',
        family_remark: ''
      }
      this.addEditShow = true
    },
    editLink (row) {
      this.titleName = '编辑紧急联系人'
      this.isAdd = false
      this.addEditForm = {
        id: row.id,
        ep_id: row.ep_id,
        family_name: row.family_name,
        family_relation: row.family_relation,
        family_phone: row.family_phone,
        family_home_phone: row.family_home_phone,
        family_address: row.family_address,
        family_remark: row.family_remark
      }
      this.addEditShow = true
    },
    delLink (row) {
      let name = row.family_name
      this.$confirm('此操作将永久删除该紧急联系人【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          id: row.id
        }
        deleteelderlyfamilyperson(data).then(res => {
          this.getFamilyTable()
          this.$notify({title: '成功', message: '成功删除联系人', type: 'success', duration: 2000})
        }).catch(() => {})
      })
    },
    closeAddEdit () {
      this.addEditShow = false
    },
    submitAddEditUnit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            createelderlyfamilyperson(this.addEditForm).then(res => {
              this.getFamilyTable()
              this.$notify({title: '成功', message: '成功新增联系人', type: 'success', duration: 2000})
              this.addEditShow = false
            }).catch(() => {})
          } else {
            updateelderlyfamilyperson(this.addEditForm).then(res => {
              this.getFamilyTable()
              this.$notify({title: '成功', message: '成功编辑联系人', type: 'success', duration: 2000})
              this.addEditShow = false
            }).catch(() => {})
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/kinsmanInfo.vue